export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_12.52b90f62.jpg";